const vueProduct = new Vue({
	name: 'vueLetteringProduct',
	el: '#vueProduct',
	data: {
		productType: vueProduct_DATA.productType,
		maxMinRules: vueProduct_DATA.maxMinRules,
		letterFixings: vueProduct_DATA.letterFixings,
		displayDimensions: {
			height: 200,
			thickness: 0,
		},
		product: {
			productId: GLOBAL.PRODUCT.ID,
			fixings: 0,
			selectedFont: '',
			dimensions: {
				unit: 'mm',
				height: 200,
				thickness: 0,
			},
			materialId: 0,
		},
		defaultValues: [
			{
				name: 'height',
				field: 'height',
				min: 50,
				max: 3050,
				value: 100,
			},
		],
		colourMatrixItems: [],
		thicknessOnly: false,
		hasColours: false,
		thicknesses: {},
		isUpdating: false,
		fonts: vueProduct_DATA.fonts,
		weights: [],
		selectedIndex: 0,
		salePrice: 0,
		quantityPrice: 0,
		quantitySalePrice: 0,
		typingTimer: null, //timer identifier
		doneTypingInterval: 1500, //time in ms (1.5 seconds)
		gettingPrice: false,
		disableFonts: false,
	},
	mounted() {
		const vm = this;
		vm.setMaxMinProperties();

		if (document.getElementById('height')) {
			const element = document.getElementById('height');
			element.addEventListener('input', isItANumber);

			element.addEventListener(`keyup`, () => {
				clearTimeout(vm.typingTimer);
				if (element.value) {
					vm.typingTimer = setTimeout(doneTyping, vm.doneTypingInterval);
				}
			});

			function isItANumber(e) {
				if (isNaN(e.target.value)) {
					vm.notANumber(e.target.value);
				} else {
					document.getElementById('invalid-number-error').classList.add('d-none');
				}
			}
		}

		function doneTyping() {
			vm.getProductPrice();
		}

		if (document.getElementById('typeface-preview')) {
			const element = document.getElementById('typeface-preview');
			element.addEventListener(`keyup`, () => {
				clearTimeout(vm.typingTimer);
				if (element.value) {
					vm.typingTimer = setTimeout(doneTyping, vm.doneTypingInterval);
				}
			});
		}
	},
	mixins: [
		addToCartBarMixin,
		calcEngineServiceMixin,
		coloursMixin,
		generalMixin,
		hatchMixin,
		onLoadPropertiesMixin,
		modalsMixin,
		optionalExtrasMixin,
		productMixin,
		productPriceMixin,
		productServiceMixin,
		quantityMixin,
		requestServiceMixin,
		shoppingCartServiceMixin,
		toggleMixin,
		unitsMixin,
		validationMixin,
		vatMixin
	],
	methods: {
		/**
		 * Updates the product price
		 * @@param {boolean} textInput Whether the field is a text input
		 */
		updateProductPrice: function () {
			if (
				document.querySelector('input[name="font-type"]:checked') ||
				document.querySelector('#type-of-plastic').value != 0 ||
				document.querySelector('#thickness').value != 0
			) {
				const vm = this;
				vm.getProductPrice();
				vm.isLimitedOrOutOfStock();
			}
			/*vm.validate();*/
		},
		resetThickness: function () {
			const vm = this;
			vm.product.dimensions.thickness = 0;
		},
		checkCharacters: function (value) {
			const vm = this;

			const reg = /[^a-zA-Z0-9\@\£\&\!\#\$\ ]+/;
			if (reg.test(value)) {
				vm.product.text = value.slice(0, -1);
			}
		},
		notANumber: function (value) {
			const numberError = document.getElementById('invalid-number-error');
			numberError.classList.remove('d-none');
			document.getElementById('height').value = value.slice(0, -1);
		},
		/**
		 * Loads the thickness data for plastic selected in the type of plastic dropdown
		 */
		loadThicknessData: function () {
			const vm = this;

			const data = {
				productId: vm.product.materialId,
			};

			vm.getProductThicknesses(data).then(function (response) {
				if (!response) return;

				const content = response.data;

				vm.thicknesses = content;
				vm.thicknessOnly = true;
			});
		},
		/**
		 * Changes the type of plastic dropdown
		 */
		changeTypeOfPlastic: function () {
			const vm = this;
			vm.resetColours();
			vm.resetThickness();
			/*vm.validate();*/

			if (Number(vm.product.materialId) === 0) {
				vm.thicknessOnly = false;
				return;
			}

			const data = {
				productId: vm.product.materialId
			};

			vm.getProductColours(data).then(function (response) {
				if (!response) return;

				const content = response.data;

				if (content.length > 0) {
					vm.colourMatrixItems = content;
					vm.addColours(content);
					vm.hasColours = true;
					vm.$refs['selectColor'].required = true;
				} else {
					vm.loadThicknessData();
				}
			});
		},
		setFontFamily: function (font, index) {
			const vm = this;
			vm.selectedIndex = index;
			vm.product.selectedFont = font;
			vm.updateProductPrice();
		},
		validate: function () {
			const vm = this;
			vm.clearErrors();

			if (!vm.requiredFieldsAreValid()) {
				return false;
			}

			return true;
		},
		/**
		 * Adds item to basket
		 */
		addToBasket: function () {
			const vm = this;

			if (vm.isAddingToCart) {
				return;
			}

			if (!vm.validate()) return;

			vm.isAddingToCart = true;

			vm.addLetteringProductApi(vm.product)
				.then(function (response) {
					if (!response) {
						vm.isAddingToCart = false;
						vueAddToCartModal.openError();
						return;
					}

					const content = response.data.content;

					if (content.badData) {
						vueAddToCartModal.openError();
						return;
					}

					vueAddToCartModal.priceResponse = vueProduct.priceResponse
					vueAddToCartModal.quantity = vueProduct.product.quantity;
					vueAddToCartModal.addedProduct = content.addedProduct
					vueShoppingCartCount.total = content.basketItemsTotal;

					vueAddToCartModal.open();
				})
				.catch(function () {
					vueAddToCartModal.openError();
				})
				.finally(() => {
					vm.isAddingToCart = false;
				});
		},
		checkIfGettingPrice: async function () {
			return new Promise((resolve) => {
				if (this.gettingPrice) {
					setTimeout(this.checkIfGettingPrice, 100);
				} else {
					resolve();
				}
			});
		},
		getProductPrice: async function () {
			const vm = this;
			vm.isUpdating = true;
			const data = vm.product;

			await this.checkIfGettingPrice().then(() => {
				if (
					vm.product.materialId != 0 &&
					vm.product.dimensions.thickness != 0 &&
					vm.product.dimensions.height != 0 &&
					vm.product.selectedFont &&
					vm.product.text &&
					vm.product.text != ''
				) {
					vm.disableFonts = true;

					vm.getLetteringProductPriceApi(data).then(function (response) {
						vm.isUpdating = false;
						vm.gettingPrice = true;

						if (!response) return;

						const content = response.data.content;

						vm.priceResponse = content.productPrice;

						if (vm.priceResponse.productId !== 0) {
							vm.product.id = vm.priceResponse.productId;
						} else {
							vm.product.id = GLOBAL.PRODUCT.ID;
						}

						vm.hasCampaign = content.hasCampaign


						vm.showFromPrice = false;
						vm.isUpdating = false;
						vm.gettingPrice = false;
						vm.disableFonts = false;
					});
				}
			});
		}
	},
	watch: {
		'product.text': function () {
			const vm = this;

			if (document.querySelector('.is-invalid')) {
				vm.validate();
			}
		},

		'product.selectedFont': function () {
			const vm = this;

			if (document.querySelector('.is-invalid')) {
				setTimeout(function () {
					vm.validate();
				}, 100);
			}
		},
		'product.materialId': function () {
			const vm = this;

			if (document.querySelector('.is-invalid')) {
				setTimeout(function () {
					vm.validate();
				}, 100);
			}
		},
	},
});
